@if (extensionRuleInformations) {
<div class="extension-rule-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>
            {{ 'ExtensionRule.Title' | translate }} {{ extensionRuleInformations.id ? '"' + extensionRuleInformations.id + '"' : '' }}
            {{ (!isCreation && extensionRuleInformations.extensionId ? 'ExtensionRule.TitleAdd' : '') | translate }}
            {{ !isCreation && selectedExtension ? (selectedExtension | extensionDisplay) : '' }}
        </span>
    </div>
    <div class="content">
        @if (extensionRuleInformations !== undefined) {
        <form [formGroup]="extensionRuleForm" (ngSubmit)="onSubmit()">
            <div class="form-content">
                <mat-card appearance="outlined" class="box default-card">
                    <mat-card-content>
                        <div class="check-form-field">
                            <mat-label>{{ 'ExtensionRule.EnabledPlaceholder' | translate }}</mat-label>
                            <mat-checkbox formControlName="enabled">{{ 'ExtensionRule.EnabledPlaceholder' | translate }}</mat-checkbox>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'ExtensionRule.ExtensionPlaceholder' | translate }}</mat-label>
                                <input type="text" matInput formControlName="extension" autocomplete="off" readonly />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'ExtensionRule.RingStatePlaceholder' | translate }}</mat-label>
                                <mat-select formControlName="ringState">
                                    @for (state of ringStates; track state) {
                                    <mat-option [value]="state">
                                        {{ 'EnumRingStates.' + state | translate }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'ExtensionRule.RingSecondsPlaceholder' | translate }}</mat-label>
                                <mat-select formControlName="ringSeconds">
                                    <mat-option [value]="5">5</mat-option>
                                    <mat-option [value]="10">10</mat-option>
                                    <mat-option [value]="15">45</mat-option>
                                    <mat-option [value]="20">20</mat-option>
                                    <mat-option [value]="25">25</mat-option>
                                    <mat-option [value]="30">30</mat-option>
                                    <mat-option [value]="35">35</mat-option>
                                    <mat-option [value]="40">40</mat-option>
                                    <mat-option [value]="45">45</mat-option>
                                    <mat-option [value]="60">60</mat-option>
                                    <mat-option [value]="90">90</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'ExtensionRule.TargetTypePlaceholder' | translate }}</mat-label>
                                <mat-select formControlName="targetType" (valueChange)="targetTypeChange($event)">
                                    @for (target of targetTypes; track target) {
                                    <mat-option [value]="target">
                                        {{ 'EnumRuleTargetTypes.' + target | translate }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        @if (extensionRuleForm.get('targetType').value === ruleTargetTypes.external) {
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'ExtensionRule.TargetPlaceholder' | translate }}</mat-label>
                                <input matInput formControlName="target" autocomplete="off" />
                            </mat-form-field>
                        </div>
                        } @if (extensionRuleForm.get('targetType').value === ruleTargetTypes.extension) {
                        <div>
                            <mat-form-field style="width: 210px">
                                <mat-label>{{ 'ExtensionRule.TargetPlaceholder' | translate }}</mat-label>
                                <input type="text" matInput [matAutocomplete]="auto" formControlName="extensionTarget" />
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayExtension" (optionSelected)="extensionsTargetChange($event)">
                                    @for (targetExtension of targetExtensionsOptions | async; track targetExtension) {
                                    <mat-option [value]="targetExtension">
                                        {{ targetExtension | extensionDisplay }}
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        } @if (extensionRuleForm.get('targetType').value === ruleTargetTypes.service) {
                        <div>
                            <mat-form-field style="width: 210px">
                                <mat-label>{{ 'ExtensionRule.TargetPlaceholder' | translate }}</mat-label>
                                <input type="text" matInput [matAutocomplete]="auto" formControlName="serviceTarget" />
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayService" (optionSelected)="servicesTargetChange($event)">
                                    @for (targetService of targetServicesOptions | async; track targetService) {
                                    <mat-option [value]="targetService">
                                        {{ targetService.name }}
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        }
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'ExtensionRule.CalendarPlaceholder' | translate }}</mat-label>
                                <mat-select formControlName="calendarId">
                                    @for (calendar of calendars; track calendar) {
                                    <mat-option [value]="calendar.id">
                                        {{ calendar.name }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="save-button">
                <button mat-stroked-button color="accent" type="button" routerLink="/extension" [queryParams]="{ id: extensionId }" [state]="{ tab: 'rule' }">
                    {{ 'ExtensionRule.CancelButton' | translate }}
                </button>
                <button mat-raised-button color="accent" [disabled]="!extensionRuleForm.valid" type="submit">{{ 'ExtensionRule.SubmitButton' | translate }}</button>
            </div>
        </form>
        }
    </div>
</div>
}
